import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  html,
  body {
    margin: 5px;
    padding: 3px;
    overflow: hidden;
  }

  body {
    background-color: #000009;
    color: yellow;
  }

  #root {
    margin: 5px;
  }
`;

export default GlobalStyles;

